import Prism from 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

import 'prismjs/components/prism-javascript.min'
import 'prismjs/components/prism-markup.min'
import 'prismjs/components/prism-bash.min'
import 'prismjs/components/prism-jsx.min'

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: { Prism }
  }
})
